import { apiAxiosCMS } from 'services/api';
import { DataFormProps } from './typeForm';
import { ItemFromElementMenuProps } from 'types/ElementMenuProps';

interface RespProps {
	isSuccess: boolean;
	data: ItemFromElementMenuProps | null;
}

export async function addNewElementIdOnBack(
	data: DataFormProps,
	slug: string,
	handleNotify: any,
	idFatherElement: string
) {
	const resp: RespProps = { isSuccess: false, data: null };

	const payload: any = {
		active: data.active,
		always_open: data.isAllwaysOpen,
		highlighted_color: data.color === '' ? null : data.color,
		language_slug: 'en',
		location_slug: slug,
		name: data.name,
		redirect_type: data.typeRedirect.option,
		redirect_value: data.valueRedirect,
		reference_value: data.urlVideo !== null ? data.urlVideo : null,
		banner_redirect_value: data.valueRedirectBanner,
		banner_file_id: data.banner === null ? null : data.banner.id,
		right_file_id: data.rightImg === null ? null : data.rightImg.id,
		left_file_id: data.leftImg === null ? null : data.leftImg.id
	};

	//se estiver adicionando o item como filho dentro de um pai é necessário add o id do pai
	if (idFatherElement !== '') {
		payload.menu_item_id = idFatherElement;
	}

	//REDIRECT DO BANNER NÃO ESTA SENDO PASSADO

	await apiAxiosCMS
		.post(`menu-items`, payload)
		.then((res) => {
			resp.isSuccess = true;
			resp.data = res?.data || null;
			handleNotify('Item salvo com sucesso!', 'success');
		})
		.catch((error) => {
			resp.isSuccess = false;
			resp.data = null;
			handleNotify(error?.message || 'Erro ao salvar o item de menu', 'error');
		});

	return resp;
}

export async function editElementIdOnBack(
	dataToEdit: ItemFromElementMenuProps,
	dataForm: DataFormProps,
	handleNotify: any
) {
	const resp: RespProps = { isSuccess: false, data: null };
	const payload = {
		active: dataForm.active,
		always_open: dataForm.isAllwaysOpen,
		highlighted_color: dataForm.color === '' ? null : dataForm.color,
		name: dataForm.name,
		redirect_type: dataForm.typeRedirect.option,
		redirect_value: dataForm.valueRedirect,
		reference_value: dataForm.urlVideo !== null ? dataForm.urlVideo : null,
		banner_redirect_value: dataForm.valueRedirectBanner,
		banner_file_id: dataForm.banner === null ? null : dataForm.banner.id,
		right_file_id: dataForm.rightImg === null ? null : dataForm.rightImg.id,
		left_file_id: dataForm.leftImg === null ? null : dataForm.leftImg.id
	};

	//REDIRECT DO BANNER NÃO ESTA SENDO PASSADO

	await apiAxiosCMS
		.patch(`menu-items/${dataToEdit.id}`, payload)
		.then((res) => {
			resp.isSuccess = true;
			resp.data = res?.data || null;
			handleNotify('Item editado com sucesso!', 'success');
		})
		.catch((error) => {
			resp.isSuccess = false;
			resp.data = null;
			handleNotify(error?.message || 'Erro ao editar o item de menu', 'error');
		});

	return resp;
}
